import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../content/i18n';
import './Footer.css';

const Footer = () => {
  const { t, isKo } = useI18n();
  return (
    <footer className="footer">
      <div className="footer-content container">
        <div className="footer-logo">
          <img src="/resource/new_AppIcon.png" alt={t.footer.iconAlt} />
        </div>
        <p className="footer-text">
          <span className="mimic-brand">{t.common.brand}</span>
          {isKo ? <span className="mimic-korean">{t.common.brandKo}</span> : null}
          {t.footer.tagline}
        </p>
        <div className="footer-contact">
          <a href="mailto:master@mimic.blog" className="footer-email link">
            master@mimic.blog
          </a>
        </div>
        <div className="footer-links">
          <Link to="/terms" className="footer-link link" target="_blank" rel="noopener noreferrer">
            {t.footer.links.terms}
          </Link>
          <Link to="/privacy" className="footer-link link" target="_blank" rel="noopener noreferrer">
            {t.footer.links.privacy}
          </Link>
        </div>
        <p className="footer-copyright">
          © 2025 BenefitBros (베네핏브로스). All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;

